import Player from '@vimeo/player';
import { useEffect, useRef } from 'react';

import { useSyncState } from '@hooks/useSyncState';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupBhcVideoPlayedOnce } from '@tracking/trackingEvents';

const BHCVideo = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const playerRef = useRef<Player | null>(null);
  const { hasControl, isSyncedAppointment } = useAppointmentContext();
  const { trackingContexts } = useTrackingContext();

  const trackBhcVideoPlayed = useTrackSignupBhcVideoPlayedOnce();

  const [isPlaying, setIsPlaying] = useSyncState<boolean>(
    'bhc-video-play',
    false
  );

  useEffect(() => {
    if (!iframeRef.current) return;

    const player = new Player(iframeRef.current);
    playerRef.current = player;

    player.on('play', () => {
      setIsPlaying(true);
      trackBhcVideoPlayed({}, { contexts: trackingContexts });
    });
    player.on('pause', () => setIsPlaying(false));
    return () => {
      player.off('play');
      player.off('pause');
    };
  }, [setIsPlaying, trackingContexts, trackBhcVideoPlayed]);

  useEffect(() => {
    const player = playerRef.current;
    if (!player) return;
    if (!isSyncedAppointment || hasControl) return;

    if (isPlaying) {
      player.play();
    } else {
      player.pause();
    }
  }, [isPlaying, isSyncedAppointment, hasControl]);

  return (
    <div className="bhc-hero__video">
      <iframe
        ref={iframeRef}
        src="https://player.vimeo.com/video/1128895505?h=0a1b2c3d4e"
        width="100%"
        height="100%"
        frameBorder="0"
        allow="autoplay; fullscreen"
        title="Boiler & Home Cover"
      />
    </div>
  );
};

export { BHCVideo };
